import React from "react";

import BarIcon from "icons/investment-facilities/investment-bar.svg";
import BikeRoomIcon from "icons/investment-facilities/investment-bike-room.svg";
import ConferenceRoomIcon from "icons/investment-facilities/investment-conference-room.svg";
import GymIcon from "icons/investment-facilities/investment-gym.svg";
import KidsIcon from "icons/investment-facilities/investment-kids.svg";
import ParkingIcon from "icons/investment-facilities/investment-parking.svg";
import PoolInsideIcon from "icons/investment-facilities/investment-pool-inside.svg";
import PoolOutsideIcon from "icons/investment-facilities/investment-pool-outside.svg";
import ReceptionIcon from "icons/investment-facilities/investment-reception.svg";
import RestaurantIcon from "icons/investment-facilities/investment-restaurant.svg";
import SaunaIcon from "icons/investment-facilities/investment-sauna.svg";
import SkiRoomIcon from "icons/investment-facilities/investment-ski-room.svg";
import SpaIcon from "icons/investment-facilities/investment-spa.svg";
import TerraceIcon from "icons/investment-facilities/investment-terrace.svg";
import PortIcon from "icons/investment-facilities/port.svg";

const facilitiesParser = (data) => {
  const items = [
    {
      icon: <BarIcon />,
      label: "Bar",
      status: !!data?.bar,
    },
    {
      icon: <BikeRoomIcon />,
      label: "Rowerownia",
      status: !!data?.bikeRoom,
    },
    {
      icon: <ConferenceRoomIcon />,
      label: "Sala konferencyjna",
      status: !!data?.conferenceRoom,
    },
    {
      icon: <GymIcon />,
      label: "Siłownia",
      status: !!data?.gym,
    },
    {
      icon: <KidsIcon />,
      label: "Strefa Kids",
      status: !!data?.kids,
    },
    {
      icon: <ParkingIcon />,
      label: "Parking",
      status: !!data?.parking,
    },
    {
      icon: <PoolInsideIcon />,
      label: "Basen wewnętrzny",
      status: !!data?.poolIn,
    },
    {
      icon: <PoolOutsideIcon />,
      label: "Basen zewnętrzny",
      status: !!data?.poolOut,
    },
    {
      icon: <ReceptionIcon />,
      label: "Recepcja",
      status: !!data?.reception,
    },
    {
      icon: <RestaurantIcon />,
      label: "Restauracja",
      status: !!data?.restaurant,
    },
    {
      icon: <SaunaIcon />,
      label: "Sauna",
      status: !!data?.sauna,
    },
    {
      icon: <SkiRoomIcon />,
      label: "Narciarnia",
      status: !!data?.skiRoom,
    },
    {
      icon: <SpaIcon />,
      label: "Spa",
      status: !!data?.spa,
    },
    {
      icon: <TerraceIcon />,
      label: "Taras widokowy",
      status: !!data?.terrace,
    },
    {
      icon: <PortIcon />,
      label: "Port jachtowy",
      status: !!data?.port,
    },
  ];

  return items;
};

export default facilitiesParser;
